var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-modal',{attrs:{"title":_vm.title,"width":"80%","height":"80%"},on:{"hide":function($event){return _vm.closed()}},model:{value:(_vm.formVisible),callback:function ($$v) {_vm.formVisible=$$v},expression:"formVisible"}},[_c('div',{staticClass:"tabBox"},[_c('vxe-table',{ref:"xTable",attrs:{"size":"mini","column-config":{ minWidth: '80px' },"show-overflow":false,"scroll-y":{ enabled: false },"border":"","height":_vm.scrollerHeight,"resizable":"","data":_vm.tableData,"mouse-config":{ area: true, extension: true },"highlight-hover-row":"","highlight-current-row":"","keyboard-config":{
          isArrow: true,
          isEnter: true,
          isTab: true,
          enterToTab: true,
          isClip: true
        },"menu-config":{
          body: { options: _vm.bodyMenus },
          visibleMethod: _vm.visibleMethod
        }},on:{"cell-menu":_vm.cellContextMenuEvent,"menu-click":_vm.contextMenuClickEvent}},[_c('vxe-column',{attrs:{"type":"seq","width":"40px","fixed":"left"}}),_c('vxe-column',{attrs:{"fixed":"left","width":"110px","field":"groupName","title":"模块","filters":[
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],"filterRender":{ name: 'FilterExtend' }}}),_c('vxe-column',{attrs:{"fixed":"left","width":"110px","field":"vuePath","title":"菜单","filters":[
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],"filterRender":{ name: 'FilterExtend' }}}),_c('vxe-column',{attrs:{"width":"160px","fixed":"left","field":"registrationInformationGroup","title":"登记信息"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
          var row = ref.row;
return [_c('div',{staticClass:"label-ellipsis"},[_vm._v(_vm._s(row.recorder))]),_c('div',{staticClass:"label-ellipsis"},[_vm._v(" "+_vm._s(_vm.ykDateFormat('yyyy-MM-dd', row.recordDate))+" ")])]}}])}),_c('vxe-column',{attrs:{"width":"50%","field":"requirementDesc","title":"需求描述"}}),_c('vxe-column',{attrs:{"field":"processingInformationGroup","title":"处理信息","min-width":"100px"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
          var row = ref.row;
return [_c('div',{staticClass:"label-ellipsis"},[_vm._v(_vm._s(row.handler)+" "+_vm._s(row.handleResult))]),(row.pid === 0 && row.handleNote)?_c('div',{staticClass:"label-ellipsis"},[_vm._v("说明: "+_vm._s(row.handleNote))]):_vm._e(),_c('div',{staticClass:"label-ellipsis"},[_vm._v(" "+_vm._s(_vm.ykDateFormat('yyyy-MM-dd', row.handleTime))+" ")])]}}])}),_c('vxe-column',{attrs:{"field":"assessmentInformationGroup","title":"评价信息","min-width":"100px"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
          var row = ref.row;
return [_c('div',{staticClass:"label-ellipsis"},[_vm._v(_vm._s(row.assessResult))]),(row.pid === 0 && row.assessNote)?_c('div',{staticClass:"label-ellipsis"},[_vm._v("说明: "+_vm._s(row.assessNote))]):_vm._e()]}}])})],1)],1)]),_c('AssessModal',{ref:"AssessModal",on:{"sureHandler":_vm.AssessSureBack}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }